<template>
  <div>
    <header>
      <nav class="header_con">
        <div class="hd_top" @click="goToHome">
          <a class="logo" href="javascript:void(0);"></a>
        </div>
        <div class="btn_allMenu" @click="viewSubMenu">
          <a href="javascript:void(0);" class="gnb_btn"></a>
        </div>
      </nav>
    </header>
    <gnb v-if="showGnb" @childs-event="hideSubMenu"/>
  </div>
</template>

<script>
import router from '@/router'
import gnb from '@/components/GNB'
import Login from '@/views/Login'

export default {
  name: 'topMenu',
  components: { gnb },
  data () {
    return {
      showGnb: false
    }
  },  
  mounted: function () {
    this.$nextTick(function() {
      window.$store
        .dispatch('Login/isLogin')
        .then((result) => {
          if (!result) {
            router.push({
              name: 'login'
            });
          }
        });
      
    });
  },
  computed: {
    // 사용자 이름
    userName () {
      return window.$store.getters['Login/getUserName']
    }
  },
  methods : {
    logout () {
      window.$store
        .dispatch('Login/logout')
        .then(() => {
          router.push('/');
        });
    },
    viewSubMenu (e) {
      this.showGnb = true;
    },
    hideSubMenu () {
      this.showGnb = false;
    },
    goToHome() {
      router.push('/order/OrderStatus');
    }
  }    
}
</script>



// WEBPACK FOOTER //
// src/components/TopMenu.vue